export const tableRowHeight = 48; // 48px === 3rem
export const tableColors = {
    borderColor: '#e0e0e0',
    selectedRow: '#ced7f4',
    hoveredRow: 'rgba(0, 0, 0, 0.04)',
    redRowColor: 'rgba(234, 0, 0, 0.07)',
    darkRedRowColor: 'rgba(234, 0, 0, 0.34)',
    yellowRowColor: 'rgba(234, 168, 0, 0.15)',
    greenRowColor: 'rgb(77,163,9, 0.2)',
    darkGreenRowColor: 'rgb(77,163,9, 0.6)',
    lightYellowRowColor: 'rgb(243, 245, 180)',
    lightGrey: '#d8d8d8',
    lightGrayRowColor: 'rgba(0, 0, 0, 0.12)',
    darkGrayRowColor: 'rgba(0, 0, 0, 0.32)',
    disabledRowColor: 'rgb(246 246 246)',
};
export const defaultRowStyle = (rowId, activeRowId) => (Object.assign({ height: tableRowHeight }, (rowId && rowId === activeRowId && { backgroundColor: tableColors.selectedRow })));
